;(function () {
	if (window.ToolboxContextSchemeInitialized) return
	window.ToolboxContextSchemeInitialized = true

	const getModal = () => document.querySelector('.change-overlay-modal')

	const normalizeModal = () => {
		const overlays = document.querySelectorAll('.change-overlay-modal')
		if (!overlays.length) return

		const primaryOverlay = overlays[0]

		if (primaryOverlay.parentElement !== document.body) {
			document.body.appendChild(primaryOverlay)
		}

		for (let i = 1; i < overlays.length; i += 1) {
			overlays[i].remove()
		}
	}

	const openModal = () => {
		normalizeModal()
		getModal()?.classList.remove('hidden')
	}

	const closeModal = () => {
		getModal()?.classList.add('hidden')
	}

	document.addEventListener('DOMContentLoaded', normalizeModal)

	document.addEventListener('click', function (event) {
		const toggleButton = event.target.closest('.header__toggle-context')
		if (toggleButton) {
			event.preventDefault()
			openModal()
			return
		}

		if (event.target.closest('.close-modal')) {
			event.preventDefault()
			closeModal()
		}
	})

	document.addEventListener('keyup', function (event) {
		if (event.code === 'Escape') closeModal()
	})

	window.closeModal = closeModal
})()
